module.exports = __webpack_public_path__ + "static/media/green-landing.478ac79d.jpg";